export const ROOT_OBJECT_ID = 'root';
